import dayjs from "dayjs";

// Indian rupee formatting with lakh/crore grouping, no paise for whole amounts.
export const money = (n) => {
  const v = Number(n) || 0;
  const whole = Number.isInteger(v) || Math.abs(v - Math.round(v)) < 0.005;
  return `₹${v.toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: whole ? 0 : 2 })}`;
};

// Catalog prices are starting prices — final price is confirmed after inspection.
export const fromPrice = (n) => `${money(n)} onwards`;
export const fmtDateTime = (iso) => dayjs(iso).format("MMM D, h:mm A");
export const fmtSlotDate = (date) => dayjs(date).format("ddd, MMM D");
export const fmtDate = (date) => (date ? dayjs(date).format("MMM D, YYYY") : "");

// Customer-facing label for a line item: owner's display_name overrides the catalogue name.
export const itemLabel = (it) => (it.display_name && it.display_name.trim()) || it.name;
// One line's text as the customer sees it (quantity hidden when the order has hide_quantities on).
export const itemLine = (it, hideQty) => (hideQty ? itemLabel(it) : `${it.qty} × ${itemLabel(it)}`);
